// import registerServiceWorker from './registerServiceWorker';
import './styles/app.scss';
import { startRoot } from './Root'

/**
 * First we will load all of this project's JavaScript dependencies which
 * includes React and other helpers. It's a great starting point while
 * building robust, powerful web applications using React + Laravel.
 */
try {
  window.app_env = process.env.NODE_ENV;
} catch (error) {
  window.app_env = 'production';
}

/**
 * Next, we will create a fresh React component instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

// require('./Root');
startRoot()

// registerServiceWorker();
